/**
 * @typedef {object} PixNavigationSeparatorSignature
 * @property {null} Element
 * @property {{}} Args
 * @property {{}} Blocks
 */

<template><hr class="pix-navigation-separator" /></template>
